//@flow

const activeConnects = (state = [], action) => {
  switch (action.type) {
    case "ADD_ACTIVE_CONNECT":
      if (state.includes(action.name)) {
        return state;
      } else {
        return [...state, action.name];
      }
    case "REMOVE_ACTIVE_CONNECT":
      if (state.includes(action.name)) {
        return state.filter(name => name !== action.name);
      } else {
        return state;
      }
    case "DROP_ACTIVE_CONNECTS":
      return [];
    default:
      return state;
  }
};

export default activeConnects;
